module.exports = __webpack_public_path__ + "static/media/default_project_completed.a4dd60fa.jpg";